import { connect } from 'react-redux';
import { getNoticeTemplates } from '../../actions/NoticeTemplates';
import TemplatesList from './TemplatesList';

const mapStateToProps = ({ noticeTemplates }) => ({
  pageCount: noticeTemplates.templates.pageCount,
  recentlyAddedTemplates: noticeTemplates.templates.recentlyAdded,
  templates: noticeTemplates.templates.list,
  fetchError: noticeTemplates.error,
});

export default connect(
  mapStateToProps,
  { getNoticeTemplates },
)(TemplatesList);
